import { useCallback, useEffect, useMemo, useState } from 'react';

type UseEarlierMessagesButtonProps = {
  earlierMessagesAvailable?: boolean;
};

export const useEarlierMessagesButton = ({ earlierMessagesAvailable = false }: UseEarlierMessagesButtonProps) => {
  const [showEarlierMessagesButton, setShowEarlierMessagesButton] = useState(false);

  const observer = useMemo(() => {
    return new IntersectionObserver(
      (entries) => {
        // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        if (entries[0].isIntersecting && earlierMessagesAvailable) {
          setShowEarlierMessagesButton(true);
        } else {
          setShowEarlierMessagesButton(false);
        }
      },
      { threshold: 0.01 }
    );
  }, [earlierMessagesAvailable]);

  useEffect(() => {
    return () => {
      observer?.disconnect();
    };
  }, [observer]);

  const setOldestMessageRef = useCallback<(node: HTMLDivElement | null) => void>(
    (node) => {
      // Disconnect from any previously observed node
      observer.disconnect();

      if (node) {
        observer.observe(node);
      }
    },
    [observer]
  );

  return {
    showEarlierMessagesButton,
    setOldestMessageRef,
  };
};
